// 定义常量

import { EventBusKey } from "@vueuse/core"

export const login_token = 'login_token'            // 本地保存token的key值
export const local_systemData = 'local_systemData'  // 本地保存信息的key值
export const local_linkageId = 'local_linkageId'    // 本地进入门店时，连锁店的id的key值

// 事件总线
export const goodChangeKey: EventBusKey<Good> = Symbol('goodChangeKey')   // 商品改变